// src/components/common/ClientNameLink.jsx
import React, { useState } from 'react';
import { useClientModal } from '../../contexts/ClientModalContext';

/**
 * Renders a client name as a subtle clickable link.
 * Turns teal + underline on hover.
 *
 * Props:
 *   client   — object with at minimum { client_id } or { client_name }
 *   children — override display text (defaults to client.client_name or client.name)
 *   style    — additional inline styles
 */
const ClientNameLink = ({ client, children, style = {} }) => {
  const { openClientModal } = useClientModal();
  const [hovered, setHovered] = useState(false);

  const isClickable = !!(client?.client_id || client?.client_name || client?.name);

  const handleClick = (e) => {
    e.stopPropagation();
    if (isClickable) openClientModal(client);
  };

  const displayName = children ?? client?.client_name ?? client?.name ?? 'Client';

  if (!isClickable) return <span style={style}>{displayName}</span>;

  return (
    <span
      onClick={handleClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        cursor: 'pointer',
        color: hovered ? '#03DAC6' : 'inherit',
        textDecoration: hovered ? 'underline' : 'none',
        ...style,
      }}
    >
      {displayName}
    </span>
  );
};

export default ClientNameLink;
